export default __webpack_public_path__ + "static/media/cert-21-day-img.1572eec0.png";